var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningLightBg = function SvgWarningLightBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CC9000",
    stroke: "#CC9000",
    strokeWidth: 0.125,
    d: "M10.703 3.802c.567-.99 2.026-.99 2.593 0l8.2 14.237c.55.96-.16 2.148-1.297 2.149H3.8c-1.137 0-1.844-1.19-1.295-2.149z",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC9000",
    d: "M22.2 17.633 14.002 3.396a2.322 2.322 0 0 0-4.004 0L1.8 17.633a2.2 2.2 0 0 0 0 2.224A2.28 2.28 0 0 0 3.802 21h16.397a2.28 2.28 0 0 0 2-1.143 2.2 2.2 0 0 0 .001-2.224m-1.3 1.473a.8.8 0 0 1-.701.394H3.802a.8.8 0 0 1-.702-.394.71.71 0 0 1 0-.724L11.3 4.146a.82.82 0 0 1 1.406 0l8.199 14.238a.71.71 0 0 1-.004.723M11.25 13.5V9.75a.75.75 0 1 1 1.5 0v3.75a.75.75 0 1 1-1.5 0m1.875 3.375a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"
  })));
};
export default SvgWarningLightBg;